<template>
  <div class="app-container" id="courseFileList">
    <div class="mycontainer">
      <el-form
        ref="queryForm"
        :model="listQuery"
        :inline="true"
        label-width="80px"
      >
        <el-form-item label="课题属性" prop="ktsx">
          <el-select
            ref="ktsx"
            v-model="listQuery.ktsx"
            placeholder="请选择课题属性"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in ktsxOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="文件类型" prop="wjlx">
          <el-select
            ref="wjlx"
            v-model="listQuery.wjlx"
            placeholder="请选择文件类型"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in wjlxOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="所属阶段" prop="ssjd">
          <el-select
            ref="ssjd"
            v-model="listQuery.ssjd"
            placeholder="请选择所属阶段"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in ssjdOptions"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="负责人" prop="fzr">
          <el-select
            ref="fzr"
            v-model="listQuery.fzr"
            placeholder="请选择负责人"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in fzrOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="文件名称" prop="wjmc">
          <el-input
            v-model="listQuery.wjmc"
            placeholder="请输入文件名称"
            clearable
            size="small"
            style="width: 200px"
          />
        </el-form-item>

        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="getList"
            >查询</el-button
          >

          <el-button
            v-if="user.courseAdmin == 1"
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="openUpload"
            style="
              margin-left: 15px;
              color: #fff;
              background-color: #1c84c6;
              border-color: #1c84c6;
            "
            >文件模板</el-button
          >
        </span>
      </el-form>
    </div>
    <div>
      <el-table
        :max-height="height"
        v-loading="course.courseList.fileList.listLoading"
        :data="course.courseList.fileList.item"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="操作"
          min-width="230px"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <!-- <el-button type="text" size="small">预览</el-button> -->
            <el-button
              size="mini"
              type="primary"
              @click="downloadFile(scope.row)"
              >下载</el-button
            >
            <el-button
              size="mini"
              type="primary"
              plain
              @click="toBz(scope.row)"
              style="margin-left: 5px"
              >添加备注</el-button
            >
            <el-popconfirm
              title="确定删除吗？"
              @confirm="deleteFile(scope.row.fileId)"
            >
              <el-button
                v-if="user.courseAdmin == 1"
                slot="reference"
                type="danger"
                size="mini"
                style="margin-left: 5px"
                >删除</el-button
              >
            </el-popconfirm>
            <!-- <el-button type="danger" size="mini" style="margin-left:5px">删除</el-button> -->
          </template>
        </el-table-column>
        <el-table-column
          label="课题属性"
          align="left"
          prop="groupName"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="上传人"
          align="left"
          prop="username"
          min-width="80px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="上传时间"
          align="left"
          prop="uploadTime"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="所属阶段"
          align="left"
          prop="stepName"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="文件名称"
          align="left"
          prop="fileName"
          min-width="300px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-link @click="openPreview(scope.row)" type="primary">{{
              scope.row.fileName
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
          label="文件大小"
          align="right"
          prop="fileSize"
          min-width="70px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">{{ scope.row.fileSize }}M</template>
        </el-table-column>
        <el-table-column
          label="文件类型"
          align="left"
          prop="fileTypeName"
          min-width="70px"
          :show-overflow-tooltip="true"
        ></el-table-column>

        <el-table-column
          label="备注"
          align="left"
          prop="remark"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="course.courseList.fileList.count > 0"
        :total="course.courseList.fileList.count"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>

    <el-dialog
      title="编辑备注"
      :closeOnClickModal="false"
      :visible.sync="bzDialog"
      width="500px"
      top="100px"
      :modal="false"
    >
      <el-input
        v-model="file.remark"
        type="textarea"
        :rows="3"
        placeholder="请输入内容"
        show-word-limit
        maxlength="100"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="saveBz">保存</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="模板上传"
      :visible.sync="upDialog"
      width="60%"
      :closeOnClickModal="false"
      v-if="upDialog"
      destroy-on-close
    >
      <el-form ref="upForm" label-width="100px">
        <el-form-item label="课题属性：" prop="group">
          <el-radio-group v-model="parm.group" @change="groupChange">
            <el-radio
              v-for="item in ktsxOptions"
              :key="item.dictValue"
              :label="item.dictValue"
              >{{ item.dictLabel }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="所属阶段：" prop="step">
          <el-radio-group v-model="parm.step" @change="stepChange">
            <el-radio label="3">立项阶段</el-radio>
            <el-radio label="4" v-show="parm.group !== '3'">中期检查</el-radio>
            <el-radio label="6">结项阶段</el-radio>
            <el-radio label="7">课题分享</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="文件上传：" style="margin: 10px 0">
          <el-upload
            accept=".xls, .xlsx, .doc, .docx, .rar, .zip, .pdf, .txt, .ppt, .pptx"
            ref="upload"
            :action="action"
            :data="parm"
            :headers="headers"
            :on-change="handleChange"
            :before-upload="beforeUpload"
            :file-list="fileList"
            :show-file-list="false"
          >
            <el-button type="primary" icon="el-icon-upload" plain
              >附件</el-button
            >
            <div style="text-align: left">
              支持扩展名：.rar .zip .doc .docx .pdf .xlsx .xls .txt .ppt .pptx
              <br />规则一：由于网络宽带原因，限制最大文件为50M
              <br />规则二：两个或者两个以上的文件，支持压缩上传
              <br />规则三：大文件、大附件的需由管理组在客户端上传
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import { getDictData } from "@/api/task.js";
import { getCourseQueryCondition } from "@/api/course.js";

export default {
  // 列表分页
  components: {
    Pagination,
  },
  data() {
    return {
      type: "0",
      height: 100,

      listQuery: {
        ktsx: "",
        wjlx: "",
        ssjd: "",
        fzr: "",
        wjmc: "",
        page: 1,
        pageSize: 50,
        courseFileInfo: {},
      },
      ktsxOptions: [],
      wjlxOptions: [],
      ssjdOptions: [],
      fzrOptions: [],
      parm: {
        group: "1",
        step: "3",
        stepName: "立项阶段",
        text: ["6/相关模板"],
        fileType: "2",
        force: 1,
      },
      total: 0,

      stepOptions: {
        3: "立项阶段",
        4: "中期检查",
        6: "结项阶段",
        7: "课题分享",
      },
      file: {},

      bzDialog: false,
      upDialog: false,
      fileList: [],
      action: window.g.apiUrl + "course/file/upload",
      headers: {
        "x-token": localStorage.getItem("token"),
      },
    };
  },
  computed: {
    ...mapGetters(["course", "user"]),
  },
  created() {
    if (!this.user.xm) {
      this.$store.dispatch("common/fetchUserInfoAction");
    }
    //课题属性
    getDictData("pmp_course_group", 1).then((res) => {
      if (res.code === 0) {
        this.ktsxOptions = res.data;
      }
    });

    //文件类型
    getDictData("pmp_course_file_type", 1).then((res) => {
      if (res.code === 0) {
        this.wjlxOptions = res.data;
      }
    });

    //课题负责人
    getCourseQueryCondition({ type: 4 }).then((res) => {
      if (res.code === 0) {
        this.fzrOptions = res.data;
      }
    });

    //所属阶段
    getDictData("pmp_course_step", 1).then((res) => {
      if (res.code === 0) {
        this.ssjdOptions = res.data;
      }
    });
    this.listQuery.ktsx = this.$route.query?.ktsx;
    this.listQuery.wjlx = this.$route.query?.wjlx;
    this.listQuery.ssjd = this.$route.query?.ssjd;
    this.getList();
  },
  methods: {
    getList() {
      // let fzr = this.listQuery.fzr ? this.listQuery.fzr.join(",") : null;

      const params = {
        page: this.listQuery.page,
        pageSize: this.listQuery.pageSize,
        step: this.listQuery.ssjd,
        fileType: this.listQuery.wjlx,
        group: this.listQuery.ktsx,
        courseLeader: this.listQuery.fzr,
        fileName: this.listQuery.wjmc,
      };

      this.$store
        .dispatch("course/fetchCourseFileListAction", {
          params,
        })
        .then((res) => {
          if (res.code == 0) {
            const docH = document.documentElement.clientHeight;
            const mycontainerH =
              document.querySelector(".mycontainer").clientHeight;
            this.height = docH - mycontainerH - 165;
          }
        });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    toBz(file) {
      this.file = file;
      this.bzDialog = true;
    },
    saveBz() {
      const params = { fileId: this.file.fileId, remark: this.file.remark };
      if (this.file.remark === "") {
        this.$message.error("备注不能为空！");
        return;
      }
      this.$store
        .dispatch("course/fetchUpdateBzAction", {
          params,
        })
        .then((success) => {
          if (success.code === 0) {
            this.getList();
            this.bzDialog = false;
          } else {
            this.$message.error(success.msg);
          }
        });
    },
    openPreview(row) {
      this.$store.dispatch("course/addBrowseCountAction", {
        fileId: row.fileId,
      });
      const url = row.previewUrl;
      window.open(url);
    },
    downloadFile(row) {
      this.$store.dispatch("course/addDownloadCountAction", {
        fileId: row.fileId,
      });
      const filePath = row.serverPath;
      const fileName = row.fileName;
      const url =
        window.g.apiUrl +
        "system/downloadFile?fileName=" +
        fileName +
        "&filePath=" +
        filePath;
      // 组装a标签
      const elink = document.createElement("a");
      // 设置下载文件名
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = url;
      document.body.appendChild(elink);
      elink.click();
      document.body.removeChild(elink);
    },
    openUpload() {
      this.upDialog = true;
    },
    groupChange() {
      if (this.parm.group === "3" && this.parm.step === "4") {
        this.parm.step = "3";
      }
    },
    stepChange() {
      this.parm.stepName = this.stepOptions[this.parm.step];
    },
    beforeUpload(file) {
      // 验证文件大小
      const isLt50M = file.size / 1024 / 1024 < 50;
      if (!isLt50M) {
        this.$message.error(file.name + "文件大小超出限制，请修改后重新上传");
        return false;
      }
    },
    handleChange(file, fileList) {
      if (file.status === "success") {
        if (file.response && file.response.code === 0) {
          this.$message.success("上传成功！");
          this.upDialog = false;
          this.getList();
        } else {
          this.$message.error("上传出错啦！错误信息：" + file.response.msg);
        }
      }
    },
    deleteFile(fileId) {
      this.$store
        .dispatch("course/fetchDeleteFileAction", {
          fileId,
        })
        .then((success) => {
          if (success.code === 0) {
            this.$message.success("操作成功！");
            this.getList();
          } else {
            this.$message.error(success.msg);
          }
        });
    },
  },
};
</script>
<style lang="less" scoped>
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.red {
  color: #ff0000 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey {
  color: #606266 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.grey2 {
  color: #999 !important;
  border-color: #fff !important;
  background-color: #fff;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}

.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.row {
  margin-top: 15px;
  .title {
    height: 44px;
    background-color: #d7d7d7;
    padding-left: 15px;
    font-size: 16px;
    line-height: 44px;
    margin-bottom: 15px;
  }
  .step-wrap {
    padding: 0 10%;
  }
  .apply-info {
    display: flex;
    height: 44px;
    line-height: 44px;
    .item {
      padding: 0 50px;
    }
    div {
      display: flex;
    }
  }
}
.myRadio {
  margin-right: 5px;
}
.gray {
  background-color: #ddd;
  border-color: #ddd;
}
</style>
